import api from "./base/API.js";

const resource = "InfoSection";
export default {
	get() {
		return api.get(resource);
	},

	getInfoSection(id) {
		return api.get(resource + "/" + id);
	},
};
